import {PullRequestAndBranchPickerSearchServerQuery} from '@github-ui/server-persisted-queries'
import type {PullRequestAndBranchPickerSearchServerQueryQuery} from '@github-ui/server-persisted-queries/types/PullRequestAndBranchPickerSearchServerQuery'
import {reactFetchJSON} from '@github-ui/verified-fetch'

import type {PullRequestAndBranchPickerFragment} from './pull-request-and-branch-picker-search-query-types'

export type PullRequestAndBranchPickerSearchQueries = {
  commenters: string
  mentions: string
  assignee: string
  author: string
  open: string
  resource: string
  queryIsUrl: boolean
}

export function pullRequestAndBranchPickerSearchQueryKey(
  issueOwner: string,
  issueRepo: string,
  issueNumber: number,
  queries: PullRequestAndBranchPickerSearchQueries,
) {
  return ['item-picker', 'pull-request-and-branch-picker-search', issueOwner, issueRepo, issueNumber, queries] as const
}

export async function fetchPullRequestAndBranchPickerSearch(
  issueOwner: string,
  issueRepo: string,
  issueNumber: number,
  queries: PullRequestAndBranchPickerSearchQueries,
  signal?: AbortSignal,
): Promise<PullRequestAndBranchPickerFragment> {
  const params = new URLSearchParams({
    commenters: queries.commenters,
    mentions: queries.mentions,
    assignee: queries.assignee,
    author: queries.author,
    open: queries.open,
    resource: queries.resource,
    queryIsUrl: String(queries.queryIsUrl),
    queryId: PullRequestAndBranchPickerSearchServerQuery,
  })

  const response = await reactFetchJSON(
    `/${issueOwner}/${issueRepo}/issues/${issueNumber}/pull_request_and_branch_picker_search?${params.toString()}`,
    {signal},
  )
  if (!response.ok) throw new Error(`Pull request and branch picker search failed (${response.status})`)

  const json = (await response.json()) as {
    data?: PullRequestAndBranchPickerSearchServerQueryQuery
    errors?: unknown[]
  }
  if (!json.data) throw new Error('Pull request and branch picker search query returned no data')

  return json.data
}
